(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tt-faq-browser"] && !Shopify.designMode) return;
  try {
    (function() {
  var instances = new WeakMap();
  function initialize(root) {
    if (instances.has(root)) return;
    var controls = root.querySelector('[data-tt-faq-filters]');
    var filters = Array.from(root.querySelectorAll('[data-tt-faq-filter]'));
    var panels = Array.from(root.querySelectorAll('[data-tt-faq-panel]'));
    var compact = root.dataset.ttFaqMode === 'compact';
    if (!controls || !filters.length || !panels.length) return;
    function select(category, focus) {
      var selected = filters.find(function(filter) { return filter.dataset.ttFaqFilter === category; });
      if (!selected) return;
      filters.forEach(function(filter) {
        var active = filter === selected;
        filter.setAttribute(compact ? 'aria-selected' : 'aria-pressed', active ? 'true' : 'false');
        if (compact) filter.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function(panel) { panel.hidden = category !== 'all' && panel.dataset.ttFaqPanel !== category; });
      if (focus) selected.focus({ preventScroll:true });
    }
    function onClick(event) {
      var filter = event.target.closest('[data-tt-faq-filter]');
      if (filter && controls.contains(filter)) select(filter.dataset.ttFaqFilter, false);
    }
    function onKeydown(event) {
      if (!compact) return;
      var index = filters.indexOf(event.target);
      if (index < 0) return;
      var direction = getComputedStyle(controls).direction === 'rtl' ? -1 : 1;
      if (event.key === 'ArrowRight') index = (index + direction + filters.length) % filters.length;
      else if (event.key === 'ArrowLeft') index = (index - direction + filters.length) % filters.length;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = filters.length - 1;
      else return;
      event.preventDefault();
      select(filters[index].dataset.ttFaqFilter, true);
    }
    function onToggle(event) {
      var detail = event.target;
      if (!detail.matches('[data-tt-faq-question]') || !detail.open) return;
      detail.parentElement.querySelectorAll('[data-tt-faq-question][open]').forEach(function(other) {
        if (other !== detail) other.open = false;
      });
    }
    if (compact) {
      panels.forEach(function(panel) {
        var tab = filters.find(function(filter) { return filter.dataset.ttFaqFilter === panel.dataset.ttFaqPanel; });
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
      });
    }
    var initialCategory = compact ? 'shipping' : 'all';
    if (!filters.some(function(filter) { return filter.dataset.ttFaqFilter === initialCategory; })) initialCategory = filters[0].dataset.ttFaqFilter;
    select(initialCategory, false);
    controls.hidden = false;
    controls.addEventListener('click', onClick);
    controls.addEventListener('keydown', onKeydown);
    root.addEventListener('toggle', onToggle, true);
    instances.set(root, {
      select:select,
      destroy:function() {
        controls.removeEventListener('click', onClick);
        controls.removeEventListener('keydown', onKeydown);
        root.removeEventListener('toggle', onToggle, true);
        instances.delete(root);
      }
    });
  }
  function within(scope, callback) {
    if (scope.matches && scope.matches('[data-tt-faq-browser]')) callback(scope);
    scope.querySelectorAll('[data-tt-faq-browser]').forEach(callback);
  }
  function ready() { within(document, initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once:true });
  else ready();
  document.addEventListener('shopify:section:load', function(event) { within(event.target, initialize); });
  document.addEventListener('shopify:section:unload', function(event) {
    within(event.target, function(root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
    });
  });
  document.addEventListener('shopify:block:select', function(event) {
    var detail = event.target.closest('[data-tt-faq-question]');
    if (!detail) return;
    var root = detail.closest('[data-tt-faq-browser]');
    var instance = instances.get(root);
    if (!instance) return;
    var panel = detail.closest('[data-tt-faq-panel]');
    instance.select(panel.dataset.ttFaqPanel, false);
    detail.open = true;
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tt-share-gift"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tt-gift-share')) {
  class TTGiftShare extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.button = this.querySelector('[data-share-button]');
      this.status = this.querySelector('[data-share-status]');
      this.fallback = this.querySelector('[data-share-fallback]');
      this.input = this.querySelector('input');
      if (!this.button || !this.status || !this.fallback || !this.input) return;
      this.button.hidden = false;
      this.fallback.hidden = true;
      this.button.addEventListener('click', () => this.share(), { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async share() {
      if (this.button.disabled) return;
      const url = this.dataset.shareUrl;
      const title = this.dataset.shareTitle || document.title;
      this.status.textContent = '';
      this.fallback.hidden = true;
      this.button.disabled = true;
      try {
        if (typeof navigator.share === 'function') {
          try {
            await navigator.share({ title, url });
            return;
          } catch (error) {
            if (error.name === 'AbortError') return;
          }
        }
        if (!this.isConnected) return;
        if (navigator.clipboard?.writeText) {
          try {
            await navigator.clipboard.writeText(url);
            if (this.isConnected) this.status.textContent = this.dataset.copied;
            return;
          } catch {}
        }
        if (!this.isConnected) return;
        this.fallback.hidden = false;
        this.input.focus();
        this.input.select();
      } finally {
        this.button.disabled = false;
      }
    }
  }
  customElements.define('tt-gift-share', TTGiftShare);
}
  } catch(e) { console.error(e); }
})();

})();
